export function mutationErrorsToObject(errors) {
  return errors.reduce((allErrors, {path, message}) => {
    if (allErrors[path] == null) {
      return {
        ...allErrors,
        [path]: message,
      };
    }

    return {
      ...allErrors,
      [path]: `${allErrors[path]}; ${message}`,
    };
  }, {});
}
